import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import LeaderBoardTable from "../components/LeaderBoardTable";
import { fetchData } from "../utils/apiUtils";
import { Spinner, Alert } from "react-bootstrap";
import Layout from "../components/Layout";
import { useLang } from "../utils/LangContext";

const Leaderboard = () => {
  const { t } = useLang();
  const { hash } = useParams();

  const [game, setGame] = useState();
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadAll = async () => {
      if (!hash) {
        setError(t("No game hash provided"));
        setLoading(false);
        return;
      }

      try {
        // 1) load game info
        const gameInfo = await fetchData(`/api/v1/game/info?game_hash=${encodeURIComponent(hash)}`);
        if (gameInfo) {
          setGame(gameInfo);
        }

        // 2) load leaderboard
        const data = await fetchData(`/api/v1/team/leaderboard?game_hash=${encodeURIComponent(hash)}`);
        setLeaderboard(data?.leaderboard || []);



      } catch (err) {
        console.error(err);
        setError(t("Failed to load data. Please try again later."));
      } finally {
        setLoading(false);
      }
    };

    loadAll();
  }, [hash, t]);

  // -- UI states --

  if (loading) {
    return (
      <Layout>
        <div className="d-flex justify-content-center my-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">{t("Loading...")}</span>
          </Spinner>
        </div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <Alert variant="danger" className="my-5 text-center">
          {error}
        </Alert>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="w-100">
        <h2>
          {t("Leaderboard")}: {game?.name || ""}
        </h2>

        {leaderboard.length > 0 ? (
          <LeaderBoardTable leaderboard={leaderboard} />
        ) : (
          <p>{t("No leaderboard data available at this time.")}</p>
        )}
      </div>
    </Layout>
  );
};

export default Leaderboard;